// mui
import { Link, List, Typography } from '@mui/material';
// components
import Banner from '../../../../components/banner';
import ListItem from './AttachmentsInfoBannerListItem';
// config
import config from '../../../../config';

// ------------------------------------------------------------

const { contactEmail } = config;

const AttachmentsInfoBanner = () => (
  <>
    <Banner type={'info'}>
      <Typography>Please include the following documents with your submission:</Typography>
      <List dense disablePadding>
        <ListItem>Loss Runs (past insurance experience, if applicable 3-5 years)</ListItem>
        <ListItem>
          Employee List: employee name, date of birth, state, CDL number, exp date, # of years experience
        </ListItem>
      </List>
    </Banner>
    <Banner type={'info'}>
      <Typography>
        If you have trouble uploading any requested documents, please email them to{' '}
        <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
      </Typography>
    </Banner>
  </>
);

export default AttachmentsInfoBanner;
